var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDetected({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7324 17.9983L13.7324 3.99827C13.5579 3.69048 13.305 3.43446 12.9993 3.25634C12.6936 3.07822 12.3462 2.98437 11.9924 2.98438C11.6386 2.98437 11.2911 3.07822 10.9854 3.25634C10.6798 3.43446 10.4268 3.69048 10.2524 3.99827L2.25237 17.9983C2.07605 18.3036 1.9836 18.6502 1.98438 19.0028C1.98516 19.3554 2.07915 19.7015 2.25682 20.0061C2.43449 20.3107 2.68952 20.5629 2.99607 20.7371C3.30261 20.9113 3.64978 21.0014 4.00237 20.9983H20.0024C20.3533 20.9979 20.6979 20.9052 21.0017 20.7296C21.3054 20.5539 21.5576 20.3014 21.7329 19.9974C21.9082 19.6934 22.0004 19.3487 22.0003 18.9978C22.0002 18.6469 21.9078 18.3022 21.7324 17.9983Z",
    stroke: "#FF8F40",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 9V13",
    stroke: "#FF8F40",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 17H12.01",
    stroke: "#FF8F40",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetected);
export default __webpack_public_path__ + "static/media/detected.60fa154dc8c12d33868bd74808b9d0ae.svg";
export { ForwardRef as ReactComponent };